const CSS_ACTIVE = 'is-active';
const CSS_FADED = 'is-faded';

const MastheadElement = document.getElementById("explore");
const ParallaxRoot = document.querySelector('.RhinoMastheadBackground');
if (ParallaxRoot) {
    const ParallaxBackground = ParallaxRoot.querySelector('.RhinoMastheadBackground-background');
    const ParallaxKeyArt = ParallaxRoot.querySelector('.RhinoMastheadBackground-key');
    const ParallaxDust = ParallaxRoot.querySelector('.RhinoMastheadBackground-dust');
    const ParallaxDust2 = ParallaxRoot.querySelector('.RhinoMastheadBackground-dust2');
    const ParallaxRockLeft = ParallaxRoot.querySelector('.RhinoMastheadBackground-rock[data-index="1"]');
    const ParallaxRockMiddle = ParallaxRoot.querySelector('.RhinoMastheadBackground-rock[data-index="2"]');
    const ParallaxRockRight = ParallaxRoot.querySelector('.RhinoMastheadBackground-rock[data-index="3"]');
    const BackgroundDeltaFactor = -0.1;
    const LeftDeltaFactor = 0.8;
    const CenterDeltaFactor = 0.4;
    const RightDeltaFactor = 1.0;
    const DriftIngressTime = 1000;
    const DriftPauseTime = 2500;
    const DriftDecayTime = 5000;
    const DriftResumeTime = DriftPauseTime + DriftDecayTime;
    const MotionScaleFactor = 5.0;
    let syncFactor = 0;
    let mouseX, mouseY;
    let lastMouseEvent = 0;
    let frameTimestamp = 0;

    function lerp(start, end, progress) {
        return start + (end - start) * progress;
    }

    function easeInOutSine(x) {
        return -(Math.cos(Math.PI * x) - 1) / 2;
    }

    function calcDriftFactor() {
        const ms = Date.now() % 30000;
        const progress = ms / 30000.0;
        const rad = progress * 2 * Math.PI;
        const driftX = Math.cos(rad);
        const driftY = Math.sin(rad) * 0.5625;

        return {driftX, driftY}
    }

    function sync(timestamp) {
        if (frameTimestamp < timestamp) {
            const elapsed = timestamp - frameTimestamp;
            frameTimestamp = timestamp;

            if (PageComponents.isTabletUp()) {
                const timeSinceLastMouseEvent = Date.now() - lastMouseEvent;

                let deltaX = 0;
                let deltaY = 0;
                const {driftX, driftY} = calcDriftFactor();
                if (timeSinceLastMouseEvent < DriftResumeTime) {
                    const mouseMax = MastheadElement.getBoundingClientRect().width / 2;
                    if (timeSinceLastMouseEvent > DriftPauseTime) {
                        syncFactor = 1.0 - (timeSinceLastMouseEvent - DriftPauseTime) / DriftDecayTime;
                    } else {
                        if (syncFactor < 1.0) {
                            syncFactor += (elapsed / DriftIngressTime);
                            if (syncFactor > 1.0) syncFactor = 1.0;
                        }
                    }
                    deltaX = lerp(driftX, (mouseX / mouseMax), easeInOutSine(syncFactor));
                    deltaY = lerp(driftY, (mouseY / mouseMax), easeInOutSine(syncFactor));
                } else {
                    deltaX = driftX;
                    deltaY = driftY;
                }

                deltaX *= MotionScaleFactor;
                deltaY *= MotionScaleFactor;

                ParallaxBackground.style.transform = `translate(${-50 + BackgroundDeltaFactor * deltaX}%, ${-50 + BackgroundDeltaFactor * deltaY}%)`;
                ParallaxRockLeft.style.transform = `translate(${-50 + LeftDeltaFactor * deltaX}%, ${-50 + LeftDeltaFactor * deltaY}%)`;
                ParallaxRockMiddle.style.transform = `translate(${-50 + CenterDeltaFactor * deltaX}%, ${-50 + CenterDeltaFactor * deltaY}%)`;
                ParallaxRockRight.style.transform = `translate(${-50 + RightDeltaFactor * deltaX}%, ${-50 + RightDeltaFactor * deltaY}%)`;
            } else {
                ParallaxBackground.style.transform = null;
                ParallaxRockLeft.style.transform = null;
                ParallaxRockMiddle.style.transform = null;
                ParallaxRockRight.style.transform = null;
            }

            update();
        }
    }

    function update() {
        requestAnimationFrame(sync);
    }

    function syncMouse(e) {
        const rect = MastheadElement.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.width * .28125;
        mouseX = e.clientX - centerX;
        mouseY = e.clientY - centerY;
        lastMouseEvent = Date.now();
    }

    window.addEventListener('load', () => {
        update();
        ParallaxBackground.classList.add(CSS_ACTIVE);
        ParallaxKeyArt.classList.add(CSS_ACTIVE);
        ParallaxDust.classList.add(CSS_ACTIVE);
        ParallaxDust2.classList.add(CSS_ACTIVE);
        ParallaxRockLeft.classList.add(CSS_ACTIVE);
        ParallaxRockMiddle.classList.add(CSS_ACTIVE);
        ParallaxRockRight.classList.add(CSS_ACTIVE);
        MastheadElement.addEventListener("mousemove", syncMouse);
    });
}

const RhinoShowcase = document.querySelector('.RhinoShowcase');
if (RhinoShowcase) {
    const RhinoShowcaseVideos = RhinoShowcase.querySelectorAll('.RhinoShowcase-video');
    const RhinoShowcaseSlides = RhinoShowcase.querySelectorAll('.RhinoShowcaseSlide');
    const PackGridItems = document.querySelectorAll('.PackGridItems .PackItem');
    let activeVideo = null;
    let lastActiveSlide = null;

    function showSlide(target) {
        let isShowcaseFaded = false;
        RhinoShowcaseVideos.forEach((slide) => {
            const isActive = slide.getAttribute('data-id') === activeVideo;
            slide.classList.toggle(CSS_ACTIVE, isActive);
        });
        RhinoShowcaseSlides.forEach((slide) => {
            const isActive = slide.getAttribute('data-id') === target;
            slide.classList.toggle(CSS_ACTIVE, isActive);
            if (isActive) isShowcaseFaded = true;
        });
        RhinoShowcase.classList.toggle(CSS_FADED, isShowcaseFaded);
    }

    if (PackGridItems && PackGridItems.length > 0) {
        let first = null;
        PackGridItems.forEach((item) => {
            const target = item.getAttribute('data-id');
            function clickHandler(e) {
                e && e.stopPropagation();
                if (lastActiveSlide === target) return;
                if (item.hasAttribute('data-video')) {
                    activeVideo = item.getAttribute('data-video');
                }
                showSlide(target);
                lastActiveSlide = target;
            }
            item.addEventListener('click', clickHandler);
            if (first === null) first = clickHandler;
        });

        first();
    }
}
